import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CupraOperationModel } from '../models/cupraoperation';
import { CupraCareModel } from '../models/cupracare';
import { PiezaDesgasteCalculationModel } from '../models/pieza-desgaste-calculation';

@Injectable({
  providedIn: 'root'
})

export class CupraCalculatorService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraCalculator/";

  constructor(private http: HttpClient) { }

  public getOperationCalculationFromVersionPitstop(data: any): Observable<CupraOperationModel> {
    return this.http.post<CupraOperationModel>(this.pathAPI + this.controller + "GetOperationCalculationFromVersionPitstop", data);
  }

  public getPiezaDesgasteCalculationFromVersionPitstop(data: any): Observable<PiezaDesgasteCalculationModel> {
    return this.http.post<PiezaDesgasteCalculationModel>(this.pathAPI + this.controller + "GetPiezaDesgasteCalculationFromVersionPitstop", data);
  }

  public getCalculationFromBudget(idBudget: string): Observable<CupraOperationModel[]> {
    return this.http.get<CupraOperationModel[]>(this.pathAPI + this.controller + "GetCalculationFromBudget/" + idBudget);
  }

  public getPiezaDesgasteFromBudget(idBudget: string): Observable<PiezaDesgasteCalculationModel[]> {
    return this.http.get<PiezaDesgasteCalculationModel[]>(this.pathAPI + this.controller + "GetPiezaDesgasteFromBudget/" + idBudget);
  }

  public getCupraCareFromBudget(idBudget: string): Observable<CupraCareModel> {
    return this.http.get<CupraCareModel>(this.pathAPI + this.controller + "GetCupraCareFromBudget/" + idBudget);
  }

}
